import { render, staticRenderFns } from "./Sidebar.component.vue?vue&type=template&id=59798442&"
import script from "./Sidebar.component.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.component.vue?vue&type=script&lang=ts&"
import style0 from "./Sidebar.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports